import React from 'react';

import { MainCard } from 'components';
import RentalForm from '../../components/Rental/RentalForm';

const NewRental = () => {
    return (
        <MainCard title="Create Reservation">
            <RentalForm />
        </MainCard>
    );
};

export default NewRental;
